<template>
  <div class="container">
    <div class="head">
      <img src="../assets/images/logo-cutout.png" alt="Logo cutout" />
      <h2>
        Xsensible <br />
        community
      </h2>
    </div>
    <p>Sign up for Xsensible community</p>
    <div class="form-container">
      <div class="steps hide-mobile">
        <router-link to="step-1" class="step">
          <img src="../assets/icons/check-shape.svg" alt="" />
          <p>Your info</p>
        </router-link>
        <router-link to="step-2" class="step">
          <img src="../assets/icons/check-shape.svg" alt="" />
          <p>{{ $store.state.shoe.name || 'Add your Xsensible' }}</p>
        </router-link>
        <div class="step">
          <img src="../assets/images/03.png" alt="" />
          <p>Choose color and size</p>
        </div>
      </div>
      <div class="steps-mobile only-mobile">
        <progress-ring class="ring" :progress="66">
          <span>03.</span>
        </progress-ring>
        <p>Choose color and size</p>
      </div>
      <div class="form-row">
        <div class="form-row-one">
          <label>Color*</label>
          <v-select
            v-model="color"
            :components="{ OpenIndicator }"
            :options="colors"
            :reduce="color => color.value"
            :clearable="false"
            class="select"
          />
        </div>
        <div class="form-row-one">
          <label>Size*</label>
          <v-select
            v-model="size"
            :components="{ OpenIndicator }"
            :options="sizes"
            :clearable="false"
            class="select"
          >
            <template #no-options>
              Please select shoe color
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="end">
      <img src="../assets/icons/round-information-button.svg" alt="Info" />
      <p>
        Please let us know the size and color of the shoes you have bought
      </p>
    </div>
    <div class="end-btn-wrapper">
      <div>
        <button class="btn" @click="$router.push('step-2')">
          Previous
        </button>
      </div>
      <div>
        <button
          :disabled="!size"
          @click="next"
          class="btn btn-primary"
          style="float: right;"
        >
          <Loader v-if="$store.state.isLoading" />
          {{ $store.state.isLoading ? '' : 'Next' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Vue from 'vue'
import { getEANCode, shoeColors, shoeSizes } from '../shoeMap'
import Loader from '@/components/Loader'

const caret = Vue.component('SelectCaret', {
  render: function(createElement) {
    return createElement('img', {
      attrs: {
        src: require('../assets/icons/chevron-down.svg')
      }
    })
  }
})

export default {
  name: 'StepThree',
  components: { Loader, vSelect },
  data() {
    return {
      OpenIndicator: caret,
      size: null,
      color: null,
      allColor: shoeColors(this.$store.state.shoe.name)
    }
  },
  computed: {
    colors() {
      return this.$store.state.shoe.name
        ? shoeColors(this.$store.state.shoe.name).map((shoe, i) => ({
            label: isNaN(shoe) ? shoe : `Blue ${i + 1}`,
            value: shoe
          }))
        : []
    },
    sizes() {
      return this.color
        ? shoeSizes(this.$store.state.shoe.name, this.color)
        : []
    }
  },
  methods: {
    next() {
      if (this.size) {
        this.$store.commit('setShoe', {
          size: this.size,
          color: this.color
        })
        const { name, color, size } = this.$store.state.shoe
        this.$store.commit('setCampaignData', {
          shoeEANCode: getEANCode(name, color, size)
        })
        this.$store.dispatch('saveCustomerCareRegistration').then(() => {
          localStorage.removeItem('userData')
          this.$router.push('last-step')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/v-select-override';
.head {
  display: flex;

  h2 {
    font-size: 38px;
    margin: 0;
    padding-left: 17px;
    font-weight: normal;
  }
}
.form-container {
  margin-top: 70px;

  .steps {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    .step {
      display: flex;
      align-items: center;
      margin-bottom: 40px;

      p {
        padding-left: 22px;
        font-size: 24px;
      }
    }
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 17px;
    margin-bottom: 20px;

    label {
      display: flex;
      align-items: center;
    }

    .input {
      border: 2px solid #f1f1f1;
      border-radius: 0;
      padding: 14px 0 14px 30px;
      font-size: 16px;
    }

    @media screen and (max-width: 1023px) {
      grid-template-columns: 1fr;
    }
  }

  .form-row-one {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-column-gap: 17px;

    @media screen and (max-width: 1023px) {
      grid-template-columns: 1fr;
    }
  }
}
.end {
  display: flex;
  background-color: #f5f5f5;
  margin-top: 70px;

  img {
    padding-left: 25px;
  }

  p {
    padding: 30px;
    margin: 0;
  }
}
.end-btn-wrapper {
  margin-top: 53px;
}
</style>
